"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerFlag = void 0;
var CustomerFlag;
(function (CustomerFlag) {
    CustomerFlag["funding"] = "funding";
    CustomerFlag["gir"] = "gir";
    CustomerFlag["map"] = "map";
    CustomerFlag["emea"] = "emea";
    CustomerFlag["us"] = "us";
})(CustomerFlag || (exports.CustomerFlag = CustomerFlag = {}));
//# sourceMappingURL=CustomerFlag.js.map